import { Box, Typography } from "@mui/material";
import { RootState } from "@store/store";
import exp from "constants";
import { textDecorationLine } from "html2canvas/dist/types/css/property-descriptors/text-decoration-line";
import React from "react";
import { useSelector } from "react-redux";

// Import document arrays generated above: publicOFC, publicNonOFC, industrialOFC, industrialNonOFC
// These should be defined as per your previous steps

export interface UndertakingItem {
  id: number;
  title: string;
  description: string;
  showIf?: "ofc" | "non-ofc";
}

export interface DocumentItem {
  document_id: number;
  title: string;
  description: string;
}

type DocumentArray = DocumentItem[];

const LegacyUndertacking = [
  {
    document_id: 207,
    title:
      "Undertaking For Submission Of Legacy / Existing Application On Rajmarg Pravesh Portal",
    description:
      "That I/We shall bear the cost of any future development, widening, or improvement of the National Highway that may require shifting or relocation of the utility works, without any claim for compensation, extension of time, or delay.",
  },
];

export const industrialNonOFC = [
  {
    document_id: 61,
    title:
      "Undertaking for Bearing Repair Costs due to Laying of Underground Utilities",
    description:
      "That any expenditure incurred by NHAI for repairing damage caused to the National Highway due to the laying of the underground pipeline shall be borne entirely by the applicant agency owning the said utility line, without any claim for reimbursement or compensation.",
  },
  {
    document_id: 60,
    title: "Undertaking for Cost of Future Development",
    description:
      "That I/We shall relocate or modify the utility or its approach at our own cost if road widening, realignment, or any future development of the highway occurs.",
  },
  {
    document_id: 65,
    title: "Undertaking for Authority of Signatory",
    description:
      "That a valid Power of Attorney exists authorizing the signatory of this undertaking to execute this document on behalf of the organization. The said Power of Attorney empowers the authorized signatory to act, sign, and submit all documents pertaining to this application on behalf of the organization.",
  },
  {
    document_id: 63,
    title:
      "Undertaking for Shifting of Utility Line for Future Highway Improvement or Repair Works",
    description:
      "That if NHAI considers it necessary in the future to shift or move the utility line for any work related to improvement, maintenance, or repair of the National Highway, such shifting shall be carried out at our cost within a reasonable time not exceeding 60 days from the date of intimation.",
  },
  {
    document_id: 59,
    title: "Undertaking for Responsibility to Highway Concessionaire",
    description:
      "That I/We accept full responsibility to honor and settle any valid claims raised by the Highway Concessionaire due to utility-related activities within their project stretch or influence zone.",
  },
  {
    document_id: 62,
    title: "Undertaking for No Damage to Existing Utilities",
    description:
      "That no damage shall be caused to existing utilities during the execution of work. In case of any damage, I/We shall fully compensate the concerned agency and bear all costs for repair or restoration of any affected structure, road, or infrastructure.",
  },
  {
    document_id: 67,
    title:
      "Undertaking for electronic Performance Bank Guarantee (e-PBG) (Rate as per Ministry's Circular)",
    description:
      "That I/We shall submit a electronic Performance Bank Guarantee (e-PBG) for the Right of Way as per the Ministry's circular, at the rate of ₹100/- (Rupees One Hundred only) per meter length of the utility installation along the National Highway. I/We undertake to comply with all applicable terms, conditions, and directions issued by the Ministry of Road Transport & Highways regarding the electronic Performance Bank Guarantee (e-PBG).",
  },
  {
    document_id: 64,
    title: "Undertaking for Shifting or Relocation of Laid Pipeline",
    description:
      "That I/We shall shift or relocate the laid pipeline at my/our own cost and risk whenever required by NHAI, including but not limited to widening, or any future development of the National Highway, without any claim for compensation, extension of time, or delay.",
  },
  {
    document_id: 66,
    title:
      "Undertaking for Confirmation of electronic Performance Bank Guarantee (e-PBG) (As per NH GOG Guidelines)",
    description:
      "That the electronic Performance Bank Guarantee (e-PBG) amount has been duly calculated, verified, and confirmed as per the National Highways (Grant of Permission for Access/Utility) Guidelines (NH-GOG). I/We undertake to maintain the Performance Bank Guarantee for the duration specified by the competent authority and comply with all applicable terms and directions issued by MoRTH. In case of any breach, non-compliance, or discrepancy in the PBG, I/We accept full responsibility and agree to bear any penalties, recoveries, or actions imposed by the competent authority.",
  },
  {
    document_id: 58,
    title: "Undertaking for Traffic Management and Safety",
    description:
      "That I/We shall implement an appropriate traffic management and safety plan during the accommodation of utilities to ensure the safety of highway users, workers, and the general public.",
  },
  {
    document_id: 57,
    title: "Undertaking for Indemnity",
    description:
      "That I/We shall indemnify MoRTH/NHAI and associated stakeholders against all claims, losses, damages, or liabilities arising from execution, maintenance, or existence of the utility works.",
  },
  {
    document_id: 56,
    title: "Undertaking for Compliance with Standards and Guidelines",
    description:
      "That all works shall strictly comply with the standard conditions, technical specifications, and guidelines prescribed by MoRTH/NHAI or any competent authority.",
  },
  {
    document_id: 55,
    title: "Undertaking for Renewal / Submission of Bank Guarantee",
    description:
      "That I/We shall submit or renew the Bank Guarantee (BG) whenever requested by MoRTH or its authorized bodies. I/We undertake to maintain the Bank Guarantee in accordance with applicable guidelines and directions issued by the Ministry of Road Transport & Highways.",
  },
];

export const industrialOFC = [
  {
    document_id: 54,
    title:
      "Undertaking for Laying of Optical Fiber Cable (O.F.C.) at the Extreme Edge of R.O.W.",
    description:
      "That I/We shall lay the Optical Fiber Cable (O.F.C.) strictly along the extreme edge of the Right of Way (R.O.W.) of the National Highway, ensuring that there is no obstruction, interference, or adverse impact on the main carriageway, structures, or existing infrastructure.",
  },
  {
    document_id: 65,
    title: "Undertaking for Authority of Signatory",
    description:
      "That a valid Power of Attorney exists authorizing the signatory of this undertaking to execute this document on behalf of the organization. The said Power of Attorney empowers the authorized signatory to act, sign, and submit all documents pertaining to this application on behalf of the organization.",
  },
  {
    document_id: 63,
    title:
      "Undertaking for Shifting of Utility Line for Future Highway Improvement or Repair Works",
    description:
      "That if NHAI considers it necessary in the future to shift or move the utility line for any work related to improvement, maintenance, or repair of the National Highway, such shifting shall be carried out at our cost within a reasonable time not exceeding 60 days from the date of intimation.",
  },
  {
    document_id: 59,
    title: "Undertaking for Responsibility to Highway Concessionaire",
    description:
      "That I/We accept full responsibility to honor and settle any valid claims raised by the Highway Concessionaire due to utility-related activities within their project stretch or influence zone.",
  },
  {
    document_id: 62,
    title: "Undertaking for No Damage to Existing Utilities",
    description:
      "That no damage shall be caused to existing utilities during the execution of work. In case of any damage, I/We shall fully compensate the concerned agency and bear all costs for repair or restoration of any affected structure, road, or infrastructure.",
  },
  {
    document_id: 67,
    title:
      "Undertaking for electronic Performance Bank Guarantee (e-PBG) (Rate as per Ministry's Circular)",
    description:
      "That I/We shall submit a electronic Performance Bank Guarantee (e-PBG) for the Right of Way as per the Ministry's circular, at the rate of ₹100/- (Rupees One Hundred only) per meter length of the utility installation along the National Highway. I/We undertake to comply with all applicable terms, conditions, and directions issued by the Ministry of Road Transport & Highways regarding the electronic Performance Bank Guarantee (e-PBG).",
  },
  {
    document_id: 64,
    title: "Undertaking for Shifting or Relocation of Laid Pipeline",
    description:
      "That I/We shall shift or relocate the laid pipeline at my/our own cost and risk whenever required by NHAI, including but not limited to widening, or any future development of the National Highway, without any claim for compensation, extension of time, or delay.",
  },
  {
    document_id: 66,
    title:
      "Undertaking for Confirmation of electronic Performance Bank Guarantee (e-PBG) (As per NH GOG Guidelines)",
    description:
      "That the electronic Performance Bank Guarantee (e-PBG) amount has been duly calculated, verified, and confirmed as per the National Highways (Grant of Permission for Access/Utility) Guidelines (NH-GOG). I/We undertake to maintain the electronic Performance Bank Guarantee (e-PBG) for the duration specified by the competent authority and comply with all applicable terms and directions issued by MoRTH. In case of any breach, non-compliance, or discrepancy in the PBG, I/We accept full responsibility and agree to bear any penalties, recoveries, or actions imposed by the competent authority.",
  },
  {
    document_id: 58,
    title: "Undertaking for Traffic Management and Safety",
    description:
      "That I/We shall implement an appropriate traffic management and safety plan during the accommodation of utilities to ensure the safety of highway users, workers, and the general public.",
  },
  {
    document_id: 57,
    title: "Undertaking for Indemnity",
    description:
      "That I/We shall indemnify MoRTH/NHAI and all associated stakeholders against any claims, losses, damages, or liabilities arising from the execution, maintenance, or operation of the OFC works within the Right of Way.",
  },
  {
    document_id: 56,
    title: "Undertaking for Compliance with Standards and Guidelines",
    description:
      "That all works shall strictly comply with the standard conditions, technical specifications, and guidelines prescribed by MoRTH/NHAI or any competent authority.",
  },
  {
    document_id: 55,
    title: "Undertaking for Renewal / Submission of Bank Guarantee",
    description:
      "That I/We shall submit or renew the Bank Guarantee (BG) whenever requested by MoRTH or its authorized bodies. I/We undertake to maintain the Bank Guarantee in accordance with applicable guidelines and directions issued by the Ministry of Road Transport & Highways.",
  },
];

export const publicOFC = [
  {
    document_id: 76,
    title:
      "Undertaking for Laying of Optical Fiber Cable (O.F.C.) at the Extreme Edge of R.O.W.",
    description:
      "That I/We shall lay the Optical Fiber Cable (O.F.C.) strictly along the extreme edge of the Right of Way (R.O.W.) of the National Highway, ensuring that there is no obstruction, interference, or adverse impact on the main carriageway, structures, or existing infrastructure.",
  },
  {
    document_id: 71,
    title: "Undertaking of Indemnity",
    description:
      "That I/We shall indemnify MoRTH/NHAI and all associated stakeholders against any claims, losses, damages, or liabilities arising from the execution, maintenance, or operation of the OFC works within the Right of Way.",
  },
  {
    document_id: 73,
    title: "Undertaking for Responsibility to Highway Concessionaire",
    description:
      "That I/We accept full responsibility to honor and settle any valid claims raised by the Highway Concessionaire due to utility-related  activities within their project stretch or influence zone.",
  },
  {
    document_id: 72,
    title: "Undertaking for Traffic Management and Safety",
    description:
      "That I/We shall implement an appropriate traffic management and safety plan during the accommodation of utilities to ensure the safety of highway users, workers, and the general public.",
  },
  {
    document_id: 81,
    title:
      "Undertaking for electronic Performance Bank Guarantee (e-PBG) (Rate as per Ministry's Circular)",
    description:
      "That I/We shall submit a electronic Performance Bank Guarantee (e-PBG) for the Right of Way as per the Ministry's circular, at the rate of ₹100/- (Rupees One Hundred only) per meter length of the utility installation along the National Highway. I/We undertake to comply with all applicable terms, conditions, and directions issued by the Ministry of Road Transport & Highways regarding the electronic Performance Bank Guarantee (e-PBG).",
  },
  {
    document_id: 80,
    title:
      "Undertaking for Confirmation of electronic Performance Bank Guarantee (e-PBG) (As per NH GOG Guidelines)",
    description:
      "That the electronic Performance Bank Guarantee (e-PBG) amount has been duly calculated, verified, and confirmed as per the National Highways (Grant of Permission for Access/Utility) Guidelines (NH-GOG). I/We undertake to maintain the electronic Performance Bank Guarantee (e-PBG) for the duration specified by the competent authority and comply with all applicable terms and directions issued by MoRTH. In case of any breach, non-compliance, or discrepancy in the PBG, I/We accept full responsibility and agree to bear any penalties, recoveries, or actions imposed by the competent authority.",
  },
  {
    document_id: 79,
    title: "Undertaking for Authority of Signatory",
    description:
      "That a valid Power of Attorney exists authorizing the signatory of this undertaking to execute this document on behalf of the organization. The said Power of Attorney empowers the authorized signatory to act, sign, and submit all documents pertaining to this application on behalf of the organization.",
  },
  {
    document_id: 78,
    title: "Undertaking for Shifting or Relocation of Laid Pipeline",
    description:
      "That I/We shall shift or relocate the laid pipeline at my/our own cost and risk whenever required by NHAI, including but not limited to widening, or any future development of the National Highway, without any claim for compensation, extension of time, or delay.",
  },
  {
    document_id: 75,
    title:
      "Undertaking for Shifting of Utility Line for Future Highway Improvement or Repair Works",
    description:
      "That if NHAI considers it necessary in the future to shift or move the utility line for any work related to improvement, maintenance, or repair of the National Highway, such shifting shall be carried out at our cost within a reasonable time not exceeding 60 days from the date of intimation.",
  },
  {
    document_id: 70,
    title: "Undertaking for Compliance with Standards and Guidelines",
    description:
      "That all works shall strictly comply with the standard conditions, technical specifications, and guidelines prescribed by MoRTH/NHAI or any competent authority.",
  },
  {
    document_id: 69,
    title: "Undertaking for Renewal / Submission of Bank Guarantee",
    description:
      "That I/We shall submit or renew the Bank Guarantee (BG) whenever requested by MoRTH or its authorized bodies. I/We undertake to maintain the Bank Guarantee in accordance with applicable guidelines and directions issued by the Ministry of Road Transport & Highways.",
  },
  {
    document_id: 77,
    title: "Undertaking for No Damage to Existing Utilities",
    description:
      "That no damage shall be caused to existing utilities during the execution of work. In case of any damage, I/We shall fully compensate the concerned agency and bear all costs for repair or restoration of any affected structure, road, or infrastructure.",
  },
];

export const BharatNetOFC = [
  {
    document_id: 171,
    title:
      "Undertaking for Laying of Optical Fiber Cable (O.F.C.) at the Extreme Edge of R.O.W.",
    description:
      "That I/We shall lay the Optical Fiber Cable (O.F.C.) strictly along the extreme edge of the Right of Way (R.O.W.) of the National Highway, ensuring that there is no obstruction, interference, or adverse impact on the main carriageway, structures, or existing infrastructure.",
  },
  {
    document_id: 166,
    title: "Undertaking of Indemnity",
    description:
      "That I/We shall indemnify MoRTH/NHAI and all associated stakeholders against any claims, losses, damages, or liabilities arising from the execution, maintenance, or operation of the OFC works within the Right of Way.",
  },
  {
    document_id: 168,
    title: "Undertaking for Responsibility to Highway Concessionaire",
    description:
      "That I/We accept full responsibility to honor and settle any valid claims raised by the Highway Concessionaire due to utility-related  activities within their project stretch or influence zone.",
  },
  {
    document_id: 167,
    title: "Undertaking for Traffic Management and Safety",
    description:
      "That I/We shall implement an appropriate traffic management and safety plan during the accommodation of utilities to ensure the safety of highway users, workers, and the general public.",
  },
  // {
  //   document_id: 176,
  //   title: "Undertaking for electronic Performance Bank Guarantee (e-PBG) (Rate as per Ministry's Circular)",
  //   description:
  //     "That I/We shall submit a electronic Performance Bank Guarantee (e-PBG) for the Right of Way as per the Ministry's circular, at the rate of ₹100/- (Rupees One Hundred only) per meter length of the utility installation along the National Highway. I/We undertake to comply with all applicable terms, conditions, and directions issued by the Ministry of Road Transport & Highways regarding the electronic Performance Bank Guarantee (e-PBG)."
  // },
  // {
  //   document_id: 175,
  //   title: "Undertaking for Confirmation of electronic Performance Bank Guarantee (e-PBG) (As per NH GOG Guidelines)",
  //   description:
  //     "That the electronic Performance Bank Guarantee (e-PBG) amount has been duly calculated, verified, and confirmed as per the National Highways (Grant of Permission for Access/Utility) Guidelines (NH-GOG). I/We undertake to maintain the electronic Performance Bank Guarantee (e-PBG) for the duration specified by the competent authority and comply with all applicable terms and directions issued by MoRTH. In case of any breach, non-compliance, or discrepancy in the PBG, I/We accept full responsibility and agree to bear any penalties, recoveries, or actions imposed by the competent authority."
  // },
  {
    document_id: 174,
    title: "Undertaking for Authority of Signatory",
    description:
      "That a valid Power of Attorney exists authorizing the signatory of this undertaking to execute this document on behalf of the organization. The said Power of Attorney empowers the authorized signatory to act, sign, and submit all documents pertaining to this application on behalf of the organization.",
  },
  {
    document_id: 173,
    title: "Undertaking for Shifting or Relocation of Laid Pipeline",
    description:
      "That I/We shall shift or relocate the laid pipeline at my/our own cost and risk whenever required by NHAI, including but not limited to widening, or any future development of the National Highway, without any claim for compensation, extension of time, or delay.",
  },
  {
    document_id: 170,
    title:
      "Undertaking for Shifting of Utility Line for Future Highway Improvement or Repair Works",
    description:
      "That if NHAI considers it necessary in the future to shift or move the utility line for any work related to improvement, maintenance, or repair of the National Highway, such shifting shall be carried out at our cost within a reasonable time not exceeding 60 days from the date of intimation.",
  },
  {
    document_id: 165,
    title: "Undertaking for Compliance with Standards and Guidelines",
    description:
      "That all works shall strictly comply with the standard conditions, technical specifications, and guidelines prescribed by MoRTH/NHAI or any competent authority.",
  },
  {
    document_id: 164,
    title: "Undertaking for Renewal / Submission of Bank Guarantee",
    description:
      "That I/We shall submit or renew the Bank Guarantee (BG) whenever requested by MoRTH or its authorized bodies. I/We undertake to maintain the Bank Guarantee in accordance with applicable guidelines and directions issued by the Ministry of Road Transport & Highways.",
  },
  {
    document_id: 172,
    title: "Undertaking for No Damage to Existing Utilities",
    description:
      "That no damage shall be caused to existing utilities during the execution of work. In case of any damage, I/We shall fully compensate the concerned agency and bear all costs for repair or restoration of any affected structure, road, or infrastructure.",
  },
  {
    document_id: 200,
    title: "Undertaking for BharatNet Project",
    description: `That I/We solemnly affirm and undertake that the instant application pertains exclusively to the BharatNet Project, and that no other utility, infrastructure, or work, other than that related to the BharatNet Project, is proposed or included therein.
       That I/We further undertake that, in the event it is subsequently found that any other application has been submitted, or is being forwarded, under the guise of or in connection with the BharatNet Project, the entire responsibility and liability in this regard shall rest solely with me/us, and I/we shall be fully accountable for the same. That this undertaking is given in good faith and with full knowledge of its legal implications.`,
  },
  {
    document_id: 201,
    title: "Undertaking for Restoration of National Highway Assets",
    description: `That I/We hereby solemnly affirm and undertake that, while executing the work of laying/accommodation of Optical Fiber Cable (OFC) under the BharatNet Project, I/We shall strictly adhere to all applicable guidelines, standards, and directions issued by the Competent Authority/Highway Administration. 
      That I/We further undertake to carry out proper restoration of the National Highway (NH) land and assets, including trenches, pavements, shoulders, drains, and other affected infrastructure, to the satisfaction of the Authority, ensuring proper filling, compaction, and reinstatement as per prescribed specifications. 
      That in the event of any improper restoration, unsatisfactory compaction, or damage caused to NH assets and/or to any existing underground utilities/services resulting in interference, interruption, disruption, or failure of services, I/We agree and undertake to pay the applicable penalty as prescribed, including but not limited to ₹50 (Rupees Fifty only) per route metre for cables/wires and ₹100 (Rupees One Hundred only) per square foot for towers/stations, without any demur or objection. That this undertaking is binding and enforceable, and I/We accept full responsibility for compliance with the above conditions.`,
  },
  {
    document_id: 202,
    title: "Undertaking for Recovery of Costs and Enforcement Action",
    description: `That I/We hereby solemnly affirm and undertake that, in case of failure on my/our part to discharge the obligation of proper restoration of excavated trenches or any other restoration work related to the BharatNet Project, the Highway Authority shall have the full right to undertake such restoration work at my/our risk and cost. 
          That I/We further undertake and agree that the Authority shall be entitled to recover the entire expenditure incurred for making good the damages, along with applicable additional charges, including 15% additional fees, through the mechanism prescribed under Section 27 of the Control of National Highways (Land and Traffic) Act, 2002, without any prior notice or dispute. 
      That I/We also undertake that, in such an event: 
      (a) No further permissions or renewals of any applications submitted by me/us shall be granted until full recovery of dues; 
      (b) The Authority shall be at liberty to initiate appropriate recovery proceedings, including but not limited to auction of assets situated within the NH Right of Way (RoW), as per applicable provisions; and 
      (c) The matter may be reported to the Ministry of Road Transport & Highways and the Department of Telecommunications, and I/We shall have no objection to such action. 
      That this undertaking is irrevocable and legally binding upon me/us.`,
  },
  {
    document_id: 203,
    title: "Undertaking for Statutory Liability for Damages",
    description: `That I/We hereby solemnly affirm and undertake that I/We shall be solely responsible and liable for any damage caused to the National Highway or its assets during execution of works related to the BharatNet Project. 
      That I/We acknowledge and accept that, in addition to penalties and recovery provisions under applicable guidelines, I/We shall also be liable for penalties and legal action in accordance with the provisions of Section 8B of the National Highways Act, 1956, as amended from time to time. 
      That I/We further undertake to indemnify and keep indemnified the Government/Highway Authority against all losses, damages, claims, liabilities, and expenses arising out of or in connection with such damages. That this undertaking is given with full knowledge of its legal consequences and shall remain binding at all times.`,
  },
];

export const publicNonOFC = [
  {
    document_id: 68,
    title: "Undertaking for Cost of Future Development",
    description:
      "That I/We shall relocate or modify the utility or its approach at our own cost if road widening, realignment, or any future development of the highway occurs.",
  },
  {
    document_id: 74,
    title: "Undertaking for Bearing Repair Costs due to Laying of Underground",
    description:
      "That any expenditure incurred by NHAI for repairing damage caused to the National Highway due to the laying of the underground pipeline shall be borne entirely by the applicant agency owning the said utility line, without any claim for reimbursement or compensation.",
  },
  {
    document_id: 71,
    title: "Undertaking of Indemnity",
    description:
      "That I/We shall indemnify MoRTH/NHAI and associated stakeholders against all claims, losses, damages, or liabilities arising from execution, maintenance, or existence of the utility works.",
  },
  {
    document_id: 73,
    title: "Undertaking for Responsibility to Highway Concessionaire",
    description:
      "That I/We accept full responsibility to honor and settle any valid claims raised by the Highway Concessionaire due to utility-related activities within their project stretch or influence zone.",
  },
  {
    document_id: 72,
    title: "Undertaking for Traffic Management and Safety",
    description:
      "That I/We shall implement an appropriate traffic management and safety plan during the accommodation of utilities to ensure the safety of highway users, workers, and the general public.",
  },
  {
    document_id: 81,
    title:
      "Undertaking for Performance Bank Guarantee (Rate as per Ministry's Circular)",
    description:
      "That I/We shall submit a electronic Performance Bank Guarantee (e-PBG) for the Right of Way as per the Ministry's circular, at the rate of ₹100/- (Rupees One Hundred only) per meter length of the utility installation along the National Highway. I/We undertake to comply with all applicable terms, conditions, and directions issued by the Ministry of Road Transport & Highways regarding the electronic Performance Bank Guarantee (e-PBG).",
  },
  {
    document_id: 80,
    title:
      "Undertaking for Confirmation of electronic Performance Bank Guarantee (e-PBG) (As per NH GOG Guidelines)",
    description:
      "That the electronic Performance Bank Guarantee (e-PBG) amount has been duly calculated, verified, and confirmed as per the National Highways (Grant of Permission for Access/Utility) Guidelines (NH-GOG). I/We undertake to maintain the electronic Performance Bank Guarantee (e-PBG) for the duration specified by the competent authority and comply with all applicable terms and directions issued by MoRTH. In case of any breach, non-compliance, or discrepancy in the PBG, I/We accept full responsibility and agree to bear any penalties, recoveries, or actions imposed by the competent authority.",
  },
  {
    document_id: 79,
    title: "Undertaking for Authority of Signatory",
    description:
      "That a valid Power of Attorney exists authorizing the signatory of this undertaking to execute this document on behalf of the organization. The said Power of Attorney empowers the authorized signatory to act, sign, and submit all documents pertaining to this application on behalf of the organization.",
  },
  {
    document_id: 78,
    title: "Undertaking for Shifting or Relocation of Laid Pipeline",
    description:
      "That I/We shall shift or relocate the laid pipeline at my/our own cost and risk whenever required by NHAI, including but not limited to widening, or any future development of the National Highway, without any claim for compensation, extension of time, or delay.",
  },
  {
    document_id: 75,
    title:
      "Undertaking for Shifting of Utility Line for Future Highway Improvement or Repair Works",
    description:
      "That if NHAI considers it necessary in the future to shift or move the utility line for any work related to improvement, maintenance, or repair of the National Highway, such shifting shall be carried out at our cost within a reasonable time not exceeding 60 days from the date of intimation.",
  },
  {
    document_id: 70,
    title: "Undertaking for Compliance with Standards and Guidelines",
    description:
      "That all works shall strictly comply with the standard conditions, technical specifications, and guidelines prescribed by MoRTH/NHAI or any competent authority.",
  },
  {
    document_id: 69,
    title: "Undertaking for Renewal / Submission of Bank Guarantee",
    description:
      "That I/We shall submit or renew the Bank Guarantee (BG) whenever requested by MoRTH or its authorized bodies. I/We undertake to maintain the Bank Guarantee in accordance with applicable guidelines and directions issued by the Ministry of Road Transport & Highways.",
  },
  {
    document_id: 77,
    title: "Undertaking for No Damage to Existing Utilities",
    description:
      "That no damage shall be caused to existing utilities during the execution of work. In case of any damage, I/We shall fully compensate the concerned agency and bear all costs for repair or restoration of any affected structure, road, or infrastructure.",
  },
];

export const getDocumentArray = (
  amenity: string,
  utility_type: string,
  legacyCheck = false,
): DocumentArray => {
  let baseDocuments: DocumentArray;

  if (utility_type === "BharatNet Project") {
    baseDocuments = BharatNetOFC;
  } else {
    const amenityLower = amenity.toLowerCase();
    const isOFC = amenityLower === "ofc";
    const isPublicUtility = utility_type === "Public Utility";

    if (isPublicUtility) {
      baseDocuments = isOFC ? publicOFC : publicNonOFC;
    } else {
      baseDocuments = isOFC ? industrialOFC : industrialNonOFC;
    }
  }

  return legacyCheck
    ? [...baseDocuments, ...LegacyUndertacking]
    : baseDocuments;
};

export interface UndertakingDetails {
  Type_of_Utility?: string;
  Utility_Category?: string;

  proposed_utility_alignment?: string;
  highway_side?: string;

  start_chainage_km?: string | number;
  start_chainage_m?: string | number;
  start_chainageKm?: string | number;
  start_chainageM?: string | number;

  end_chainage_km?: string | number;
  end_chainage_m?: string | number;
  end_chainageKm?: string | number;
  end_chainageM?: string | number;

  district?: string | null;
  state?: string | null;
  national_highway_number?: string | number;
  highway_category?: string | number;
}
const UnderTackingListDetail = ({
  profile,
  amenity,
  utility_type,
  details,
  proposed_utility_alignment,
  legacyCheck,
}: {
  profile: any;
  amenity: string;
  utility_type: string;
  details?: any;
  proposed_utility_alignment?: string;
  legacyCheck?: boolean;
}) => {
  // const d: UndertakingDetails = details ?? {};

  const { start_chainage, end_chainage } = useSelector(
    (state: RootState) => state.applicationDashboard,
  );

  const bharatNetUtility = utility_type === "BharatNet Project";

  const typeOfUtility = details?.Type_of_Utility ?? amenity;
  const utilityCategory = details?.Utility_Category ?? utility_type;
  const proposedutilityType = details?.proposed_utility_alignment;
  const startKm = details?.start_chainage_km ?? details?.start_chainageKm;
  const startM = details?.start_chainage_m ?? details?.start_chainageM;
  const endKm = details?.end_chainage_km ?? details?.end_chainageKm;
  const endM = details?.end_chainage_m ?? details?.end_chainageM;

  const startChainage =
    startKm && startM ? `${startKm}+${startM}` : (start_chainage ?? "");
  const endChainage = endKm && endM ? `${endKm}+${endM}` : (end_chainage ?? "");

  const districtText =
    details?.District ??
    details?.district_name ??
    (typeof details?.district === "string" ? details?.district : undefined) ??
    profile?.district_name ??
    "";
  const stateText =
    details?.State ??
    (typeof details?.state === "string" ? details?.state : undefined) ??
    profile?.state_name ??
    "";
  const nhNumberText = details?.national_highway_number ?? "";

  const alignmentText = (
    [
      details?.proposed_utility_alignment,
      details?.proposed_utility_alignment,
      proposed_utility_alignment,
      details?.highway_side,
    ]
      .map((v) => (v == null ? "" : typeof v === "string" ? v : String(v)))
      .find((v) => v.trim().length > 0) || ""
  ).trim();

  const documentArray = getDocumentArray(
    amenity,
    utility_type,
    Boolean(legacyCheck),
  );

  return (
    <Box mb={2}>
      <Typography className="body-m" sx={{ fontSize: "14px" }}>
        I/We, <strong>{profile?.name || "__"}</strong>, as the
        Applicant/Authorized Representative, in connection with the Right of Way
        (RoW) NOC application for the proposed utility installation of{" "}
        <strong>{typeOfUtility}</strong> under the category{" "}
        <strong>{utilityCategory}</strong>,{" "}
        <strong>{proposedutilityType} </strong>
        from chainage <strong>{startChainage}</strong> KM{" "}
        {proposedutilityType?.toLowerCase() == "along the highway" &&
          endChainage && (
            <>
              to <strong>{endChainage}</strong> KM, passing through{" "}
            </>
          )}
        ,<strong>{districtText}</strong>, <strong>{stateText}</strong> on
        National Highway <strong>{nhNumberText}</strong>, do hereby solemnly
        affirm, declare, and undertake as under:
      </Typography>

      <ol
        className="body-m flex flex-col gap-4 mb-4"
        style={{ paddingLeft: "2rem", marginTop: "0.5rem", fontSize: "14px" }}
      >
        {documentArray.map((item) => (
          <li key={item.document_id}>
            <strong>{item.title}</strong>
            <br />
            <span style={{ whiteSpace: "pre-line" }}>{item.description}</span>
          </li>
        ))}
      </ol>
      <Typography className="body-m" fontSize="14px">
        <strong style={{ textDecoration: "underline" }}>Note</strong>: All
        information and documents submitted in connection with this application
        are true and correct to the best of my/our knowledge and belief. Any
        misrepresentation may render the Right of Way NOC liable for revocation,
        without prejudice to further legal action.
      </Typography>
    </Box>
  );
};

export default UnderTackingListDetail;
